import '@js/plugins/backUpButton';

export default function initPageUpButton($button) {
    $button.backUpButton('init');
}
